import Request from '../../data/request'

// need merge with the other file here...

export default class ApiIntegrationGCal {

    constructor() {}

    deleteIntegration(companyId:ID) {
        return new Request(this,'GET','integration/google_calendar/delete?company='+companyId);
    }

    forceSync(googleCalendarId:ID) {
        return new Request(this,'POST','integration/google_calendar/force-sync',{
            googleCalendarId: googleCalendarId
        });
    }


}
